/**
 * Advanced Analytics module permissions.
 * Convention: {Module}:{Action}
 */
export enum AdvancedAnalyticsPermissions {
  ALL = "Travel:AdvancedAnalytics:*",
  VIEW = "Travel:AdvancedAnalytics:View",
  EXPLORE = "Travel:AdvancedAnalytics:Explore",
  GOVERNANCE = "Travel:AdvancedAnalytics:Governance",
}

export function hasAdvancedAnalyticsAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [
      AdvancedAnalyticsPermissions.VIEW,
      AdvancedAnalyticsPermissions.ALL,
      "*",
    ].includes(p as AdvancedAnalyticsPermissions)
  );
}
